module.exports = __webpack_public_path__ + "static/media/imaginxp-loginbanner-5.b0a74adc.jpg";